<template>
  <div class="py-8">
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title class="breadcrumbs d-flex align-center">
        <v-icon class="text-light-green">{{ icons.arrowLeft }}</v-icon>
        <router-link class="text-decoration--none" :to="{ name: 'providers' }"
          >Providers</router-link
        >
      </v-toolbar-title>
    </v-app-bar>

    <div class="ma-4">
      <div class="headline font-weight-bold my-6 text-capitalize">
        Create Provider
      </div>

      <div class="d-flex my-6">
        <div class="col-md-4 col-sm-12 col-xs-12 mt-6 pa-0">
          <ProviderForm />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mdiChevronLeft } from '@mdi/js'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import ProviderForm from './components/ProviderForm'

export default {
  name: 'AddProvider',

  components: {
    ProviderForm,
    AppBarNavIcon,
  },

  data() {
    return {
      icons: {
        arrowLeft: mdiChevronLeft,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.provider-form {
  width: 400px;

  @media (max-width: 420px) {
    width: 100%;
  }
}
</style>
